import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { AddressType } from '../../enums/AddressType.js';
import { ALPHA_CHAR_PATTERN, EMPTY_TRAIL_LEADING_SPACE_PATTERN, } from '../../utils/regex.js';
import { StructuredPafData } from './StructuredPafData.js';
export class IndividualAddress extends BaseMessage {
    addressLine1;
    addressLine2;
    addressLine3;
    addressLine4;
    addressLine5;
    addressLine6;
    addressLine7;
    postCode;
    addressType;
    startDate;
    country;
    countryCode;
    pafData;
    structuredPafData;
    createdBy;
    updatedBy;
}
__decorate([
    Field.string({
        required: true,
        description: 'AddressLine1',
        maxLength: 60,
        pattern: EMPTY_TRAIL_LEADING_SPACE_PATTERN,
    }),
    __metadata("design:type", String)
], IndividualAddress.prototype, "addressLine1", void 0);
__decorate([
    Field.string({
        description: 'AddressLine2',
        maxLength: 60,
        pattern: EMPTY_TRAIL_LEADING_SPACE_PATTERN,
    }),
    __metadata("design:type", String)
], IndividualAddress.prototype, "addressLine2", void 0);
__decorate([
    Field.string({
        description: 'AddressLine3',
        maxLength: 60,
        pattern: EMPTY_TRAIL_LEADING_SPACE_PATTERN,
    }),
    __metadata("design:type", String)
], IndividualAddress.prototype, "addressLine3", void 0);
__decorate([
    Field.string({
        description: 'AddressLine4',
        maxLength: 60,
        pattern: EMPTY_TRAIL_LEADING_SPACE_PATTERN,
    }),
    __metadata("design:type", String)
], IndividualAddress.prototype, "addressLine4", void 0);
__decorate([
    Field.string({
        description: 'AddressLine5',
        maxLength: 60,
        pattern: EMPTY_TRAIL_LEADING_SPACE_PATTERN,
    }),
    __metadata("design:type", String)
], IndividualAddress.prototype, "addressLine5", void 0);
__decorate([
    Field.string({
        description: 'AddressLine6',
        maxLength: 60,
        pattern: EMPTY_TRAIL_LEADING_SPACE_PATTERN,
    }),
    __metadata("design:type", String)
], IndividualAddress.prototype, "addressLine6", void 0);
__decorate([
    Field.string({
        description: 'AddressLine7',
        maxLength: 60,
        pattern: EMPTY_TRAIL_LEADING_SPACE_PATTERN,
    }),
    __metadata("design:type", String)
], IndividualAddress.prototype, "addressLine7", void 0);
__decorate([
    Field.string({
        required: true,
        description: 'Post code',
    }),
    __metadata("design:type", String)
], IndividualAddress.prototype, "postCode", void 0);
__decorate([
    Field.enum({
        enum: AddressType,
        required: true,
        description: 'Address Type',
    }),
    __metadata("design:type", String)
], IndividualAddress.prototype, "addressType", void 0);
__decorate([
    Field.string({
        required: true,
        description: 'Start Date',
        format: 'date',
    }),
    __metadata("design:type", String)
], IndividualAddress.prototype, "startDate", void 0);
__decorate([
    Field.string({
        required: true,
        description: 'Country',
        pattern: ALPHA_CHAR_PATTERN,
    }),
    __metadata("design:type", String)
], IndividualAddress.prototype, "country", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'Country code',
        maxLength: 3,
    }),
    __metadata("design:type", String)
], IndividualAddress.prototype, "countryCode", void 0);
__decorate([
    Field.boolean({
        required: false,
        description: 'PAFData boolean flag',
    }),
    __metadata("design:type", Boolean)
], IndividualAddress.prototype, "pafData", void 0);
__decorate([
    Field.message({
        required: false,
        description: 'Structure PAF data',
    }),
    __metadata("design:type", StructuredPafData)
], IndividualAddress.prototype, "structuredPafData", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'User ID',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], IndividualAddress.prototype, "createdBy", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'User ID',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], IndividualAddress.prototype, "updatedBy", void 0);
//# sourceMappingURL=IndividualAddress.js.map